module.exports = __webpack_public_path__ + "static/img/SydneySharonMishra.52d4ab7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/SydneySharonMishra.jpg
// module id = mLIn
// module chunks = 0